export default function LinkedInLogo(props: React.ComponentProps<"svg">) {
    return (
        <svg
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g opacity="0.7" clipPath="url(#clip0_1173_3314)">
                <path
                    d="M18.8464 11.0395V17.6987C18.8464 17.8624 18.7155 17.9999 18.5452 17.9999H15.1076C14.9439 17.9999 14.8064 17.8689 14.8064 17.6987V11.5044C14.8064 9.87399 14.2237 8.76086 12.7635 8.76086C11.6504 8.76086 10.989 9.50731 10.6944 10.2341C10.5896 10.496 10.5634 10.8562 10.5634 11.2163V17.6987C10.5634 17.8624 10.4325 17.9999 10.2622 17.9999H6.8246C6.66091 17.9999 6.5234 17.8689 6.5234 17.6987C6.52995 16.0486 6.56269 8.04715 6.52995 6.16137C6.52995 5.99767 6.66091 5.86017 6.8246 5.86017H10.2557C10.4194 5.86017 10.5569 5.99113 10.5569 6.16137V7.58225C10.5569 7.58225 10.5372 7.60844 10.5307 7.62154H10.5569V7.58225C11.0938 6.75722 12.0498 5.57861 14.1909 5.57861C16.8428 5.57861 18.8333 7.31379 18.8333 11.0395H18.8464ZM0.564872 17.9999H4.00249C4.16618 17.9999 4.30369 17.8689 4.30369 17.6987V6.16137C4.30369 5.99767 4.17273 5.86017 4.00249 5.86017H0.564872C0.401176 5.86017 0.263672 5.99113 0.263672 6.16137V17.6987C0.263672 17.8624 0.394629 17.9999 0.564872 17.9999Z"
                    fill="currentColor"
                />
                <path
                    d="M2.16079 4.32157C3.35416 4.32157 4.32157 3.35416 4.32157 2.16079C4.32157 0.967417 3.35416 0 2.16079 0C0.967417 0 0 0.967417 0 2.16079C0 3.35416 0.967417 4.32157 2.16079 4.32157Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_1173_3314">
                    <rect width="18.8447" height="18" fill="currentColor" />
                </clipPath>
            </defs>
        </svg>
    )
}
